export const TICKET_STATUSES = [
  'open',
  'pending',
  'answered',
  'resolved',
  'closed',
  'archived',
  'spam',
] as const;

export type TicketStatusType = (typeof TICKET_STATUSES)[number];

export const ACTIVE_TICKET_STATUSES = ['open', 'pending', 'answered'] as const;

export type ActiveTicketStatusType = (typeof ACTIVE_TICKET_STATUSES)[number];

export const TICKET_CATEGORIES = [
  'question',
  'bug',
  'billing',
  'feedback',
  'feature_request',
  'content_report',
  'definition_issue',
  'translation_issue',
  'other',
] as const;

export type TicketCategoryType = (typeof TICKET_CATEGORIES)[number];

export const CATEGORY_LABELS: Record<TicketCategoryType, string> = {
  question: 'Question',
  bug: 'Bug Report',
  feedback: 'Feedback',
  billing: 'Billing',
  // biome-ignore lint/style/useNamingConvention: ticket category enum value
  feature_request: 'Feature',
  // biome-ignore lint/style/useNamingConvention: ticket category enum value
  content_report: 'Content Report',
  // biome-ignore lint/style/useNamingConvention: ticket category enum value
  definition_issue: 'Definition & Examples',
  // biome-ignore lint/style/useNamingConvention: ticket category enum value
  translation_issue: 'Translation Issue',
  other: 'Other',
};
